<template>
    <span class="ah-el-select-staff">
        <el-select v-model="inputVal" :disabled="disabled" placeholder="請選擇" no-data-text="無資料" no-match-text="無匹配項目" :filterable="true" style="margin-right: 5px">
            <el-option v-for="item in options" :key="item.sno" :label="item.catnam" :value="item.sno"> </el-option>
        </el-select>
        <el-tooltip class="item" effect="dark" :content="isAuth('C06') ? '新增類型' : '您沒有編輯委外類型的權限'" placement="top">
            <span>
                <el-button icon="el-icon-plus" @click="onAddBtnClick" :disabled="!isAuth('C06')"></el-button>
            </span>
        </el-tooltip>
        <SmallTextEditDialog
            :title="type == 'company' ? '新增委外廠商類型' : '新增委外勞務類型'"
            placeholder="類型名稱"
            :visible="dialog.visible"
            @close="onDialogClose"
            @add-submit="onDialogAddSubmit"
        />
    </span>
</template>
<script>
import SmallTextEditDialog from '@/components/ui/SmallTextEditDialog';

export default {
    name: 'OutsourcingTypeSelect',
    components: {
        SmallTextEditDialog,
    },
    props: {
        value: {
            Type: Number,
            default: null,
        },
        type: {
            Type: String,
            default: 'company', // company | person
        },
        disabled: Boolean,
    },
    data() {
        return {
            options_VD: [],
            options_OS: [],
            dialog: {
                visible: false,
            },
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        typeCode() {
            return this.type == 'person' ? 2 : 1;
        },
        options() {
            if (this.type == 'person') {
                return this.options_OS;
            }
            return this.options_VD;
        },
    },
    mounted() {
        this.fetchOptions();
    },
    methods: {
        fetchOptions() {
            return this.$api({
                url: '/Tool/GetDepartmentAndVendorSettings',
                method: 'get',
            }).then((resp) => {
                this.options_OS = resp.data.vendorSettings_OS;
                this.options_VD = resp.data.vendorSettings_VD;
            });
        },
        onAddBtnClick() {
            this.dialog.visible = true;
        },
        onDialogClose() {
            this.dialog.visible = false;
        },
        onDialogAddSubmit(resp) {
            this.$api({
                url: '/VendorSettingPage/Add',
                method: 'POST',
                data: {
                    type: this.typeCode,
                    catnam: resp.name,
                },
            }).then((resp) => {
                this.dialog.visible = false;
                this.fetchOptions().then(() => {
                    this.inputVal = resp.data.sno;
                });
            });
        },
    },
};
</script>
<style lang="scss">
.ah-el-select-staff {
    .el-input {
        min-width: 260px;
    }

    .el-input > input {
        cursor: text;
    }
}

.el-select-dropdown__item.staff-item {
    padding-top: 3px;
    height: 59px;

    .main {
        display: block;

        .name {
            float: left;
            padding-top: 0px;
            height: 28px;
        }

        .dep {
            float: right;
            margin-left: 10px;
            font-size: 9pt;
            font-weight: normal;
            color: #bbb;
        }
    }

    .sub {
        .email {
            position: relative;
            top: -5px;
            font-size: 9pt;
            color: #ccc;
            height: 15px;
            line-height: 15px;
            font-weight: normal;
        }
    }

    .clearfix:before,
    .clearfix:after {
        content: "";
        display: table;
    }

    .clearfix:after {
        clear: both;
    }

    .clearfix {
        *zoom: 1;
        /*For IE 6&7 only*/
    }
}
</style>
